import axios from 'axios'
import React from 'react'
import './edit-timesheet.css'
import FamilyCard from '../FamilyCard/FamilyCard'
import { baseUrl } from '../../assets/Animations'
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/20/solid'
import TimesheetWarningPopup from './TimesheetWarningPopup/TimesheetWarningPopup'

const EditTimesheet = (props) => {
    const [families, setFamilies] = React.useState([])
    const [finalWarning, setFinalWarning] = React.useState(false)
    const [note, setNote] = React.useState('')
    const [notesOpen, setNotesOpen] = React.useState(false)
    const [estimatedPay, setEstimatedPay] = React.useState(0)
    const [listOfFamiliesForTeachers, setListOfFamiliesForTeachers] = React.useState([])
    const [incompleteWarning, setIncompleteWarning] = React.useState(false)
    const [warningText, setWarningText] = React.useState([])
    const [monthNumber, setMonthNumber] = React.useState(0)
    const [currentTimesheetNumber, setCurrentTimesheetNumber] = React.useState(0)


    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }



    let d = new Date()
    let theYear = d.getFullYear()
    let theMonthNumber = d.getMonth()

    React.useEffect(() => {
        props.callForListOfFamilies(props.timesheet.school.toUpperCase())
        calculateEstimatedPay()
        createDateSettings()
    },[])

    React.useEffect(() => console.log(props.timesheet), [families])

    React.useEffect(() => {
        setFamilies(props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].families)
    }, [currentTimesheetNumber])

    React.useEffect(() => {
        if(families.length > 0) {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = "rgba(0, 128, 0, 0.747)"
            }
        } else {
            if(document.getElementById('create-timesheet__submit-btn')) {
                document.getElementById('create-timesheet__submit-btn').style.backgroundColor = 'rgba(128, 128, 128, 0.336)'
            }
        }
        calculateEstimatedPay()
        checkIfEverythingIsFilledOut()
    }, [families])

    React.useEffect(() => console.log(warningText), [warningText])

    const checkIfEverythingIsFilledOut = () => {
        setWarningText([])
        for(let i = 0; i < families.length; i++) {
            let theFamily = families[i]
            for(let i = 0; i < theFamily.lessons.length; i++) {
                if(theFamily.lessons[i].studentName === '' || theFamily.lessons[i].lessonLength === '0' || theFamily.lessons[i].date === "") {
                    setIncompleteWarning(true)
                    setWarningText(prev => [...prev, {message: `${theFamily.familyName} lesson info missing`}])
                    //return
                } else {
                    setIncompleteWarning(false)
                }    
            }
            for(let i = 0; i < theFamily.cancellations.length; i++) {
                if(theFamily.cancellations[i].student === '' || theFamily.cancellations[i].cancellor === '0' || (theFamily.cancellations[i].lessonLength === 0 && theFamily.cancellations[i].cancellor === "student less than 24hrs") || theFamily.cancellations[i].date === "") {
                    setIncompleteWarning(true)
                    setWarningText(prev => [...prev, {message: `${theFamily.familyName} cancellation info missing`}])
                    //return
                } else {
                    setIncompleteWarning(false)
                }
            }
            for( let i = 0; i < theFamily.extras.length; i++) {
                if(theFamily.extras[i].description === '' || theFamily.extras[i].amount === 0) {
                    setIncompleteWarning(true)
                    setWarningText(prev => [...prev, {message: `${theFamily.familyName} extra info missing`}])
                    //return
                } else {
                    setIncompleteWarning(false)
                }
            }
        }
        
    }

    const createDateSettings = () => {
        let d = new Date()
        let month = d.getMonth()
        let day = d.getDate()
        let theYear = d.getFullYear()
        let adjustedMonth;
        if(day < 15) {
            if(month !== 0) {
                adjustedMonth = month - 1
            } else {
                adjustedMonth = month
            }
        } else {
            adjustedMonth = month
        }
        setMonthNumber(adjustedMonth + 1)
    }

    const calculateEstimatedPay = () => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < families.length; i++) {
            let fam = families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        setEstimatedPay(((minutesTaught/60) * Number(props.timesheet.teacherRate)) + allExtras)
    }

    //ADD FAMILY
    const addFamily = () => {
        let newFamily = {
            id: Math.random().toString(16).slice(2),
            familyName: '',
            lessons: [],
            cancellations: [],
            familyWaveId: '',
            listOfFamilyStudents: [],
            email: '',
            school: '',
            extras: [],
            familyNameEntered: false
        }
        setFamilies(prev => [...prev, newFamily])
    }
    //CHANGE FAMILY NAME
    const changeFamilyName = (index, value) => {
        // let theFamiliesStudents = []
        // let theWaveId = ''
        // let theEmail = ''
        // let theSchool = ''
        // //console.log(props.listOfFamilies)
        // for(let i = 0; i < props.listOfFamilies.length; i++) {
        //     if(props.listOfFamilies[i].familyName === value) {
        //         theFamiliesStudents = props.listOfFamilies[i].students
        //         theWaveId = props.listOfFamilies[i].waveCustomerId
        //         theEmail = props.listOfFamilies[i].primaryEmail
        //         theSchool = props.timesheet.school.toUpperCase()
        //     }
        // }
        let newArr = [...families]
        newArr[index].familyName = value.familyName
        newArr[index].listOfFamilyStudents = value.students
        newArr[index].familyWaveId = value.waveCustomerId
        newArr[index].email = value.primaryEmail
        newArr[index].school = value.school
        newArr[index]._id = value._id
        setFamilies([...newArr])
    }
    const autoOpenFamilyCardWhenNameIsSelected = (index, value) => {
        if(value === '*') {
            changeFamilyName(index, value)
        } else {
            changeFamilyName(index, value)
            submitLastName(index)
        }
    }
    const submitLastName = (index) => {
        let newArr = [...families]
        newArr[index].familyNameEntered = true
        setFamilies([...newArr])
    }
    //REMOVE FAMILY
    const removeFamily = (id) => {
        setFamilies(families.filter(fam => fam.id !== id))
    }
    //ADD LESSON
    const addLesson = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            studentName: '',
            lessonLength: 0,
            studentRate: 0,
            studentAllRates: {15: 0, 30: 0, 45: 0, 60: 0},
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].lessons.push(newLesson)
        setFamilies([...newArr])
    }
    const editLesson = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].lessons[index2][key] = value
        if(key === 'studentName') {
            for(let i = 0; i < listOfFamiliesForTeachers.length; i++) {
                if(listOfFamiliesForTeachers[i].familyName === newArr[index1].familyName) {
                    let theFamiliesStudents = listOfFamiliesForTeachers[i].students
                    for(let i = 0; i < theFamiliesStudents.length; i++) {
                        if(theFamiliesStudents[i].studentName === value) {
                            newArr[index1].lessons[index2].studentRate = theFamiliesStudents[i].lessonRate
                            newArr[index1].lessons[index2].studentAllRates = theFamiliesStudents[i].allRates
                        }
                    }
                }
            }
        }
        if(value === '*') {
            newArr[index1].lessons[index2][key] = ''
            newArr[index1].lessons[index2].enterNameManually = true
        }
        setFamilies([...newArr])
    }
    const editCancellation = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].cancellations[index2][key] = value
        if(value === '*') {
            newArr[index1].cancellations[index2][key] = ''
            newArr[index1].cancellations[index2].enterNameManually = true
        }
        setFamilies([...newArr])
    }
    //REMOVE LESSON
    const removeLesson = (index, lessonId, index2) => {
        console.log(index, index2)
        let newArr = [...families]
        //remove lessons at index2
        newArr[index].lessons.splice(index2, 1)
        console.log(newArr[index].lessons)
        //newArr[index].lessons = newArr[index].lessons.filter(less => less.id !== lessonId)
        setFamilies([...newArr])
    }

    //ADD CANCELLATION
    const addCancellation = index => {
        let newLesson = {
            id: Math.random().toString(16).slice(2),
            student: '',
            cancellor: '0',
            lessonLength: 0,
            date: '',
            enterNameManually: false
        }
        let newArr = [...families]
        newArr[index].cancellations.push(newLesson)
        setFamilies([...newArr])
    }
    //REMOVE CANCELLATION
    const removeCancellation = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].cancellations = newArr[index].cancellations.filter(less => less.id !== lessonId)
        setFamilies([...newArr])
    }

    const addExtra = (index) => {
        let newExtra = {
            id: Math.random().toString(16).slice(2),
            description: '',
            amount: 0
        }
        let newArr = [...families]
        newArr[index].extras.push(newExtra)
        setFamilies([...newArr])
    }

    const editExtra = (index1, index2, value, key) => {
        let newArr = [...families]
        newArr[index1].extras[index2][key] = value
        setFamilies([...newArr])
    }

    const removeExtra = (index, lessonId) => {
        let newArr = [...families]
        newArr[index].extras = newArr[index].extras.filter(ex => ex.id !== lessonId)
        setFamilies([...newArr])
    }

    const tryToSubmitTimesheet = () => {
        if(families.length > 0 && !incompleteWarning) {
            setFinalWarning(true)
        } else {
            return
        }
    }

    const submitTimesheet = () => {
        let teachersTime = {
            timesheetId: Math.random().toString(16).slice(2),
            teacherId: props.userData.TeacherID,
            teacherName: props.userData.Name,
            families: families,
            status: 'submitted',
            note: note,
            submitDate: new Date(),
            monthYear: `${props.month}/${theYear}`,
            teacherRate: props.rate,
            school: props.userData.School,
            email: props.userData.Email,
            monthNumber: monthNumber,
            year: theYear

        }
        setFinalWarning(false)
        axios.post(`${baseUrl}/teachertimesheet`, {
            teacherTimesheet: teachersTime
        }, myHeader)
        .then((res) => {
            props.setOpenUpTheTimesheet(false)
            props.setShowNotes(false)
            props.setThankYouForSubmitting(true)
        })
        .catch((err) => {
            console.log(err)
            console.log('oops there was an error')
        })
    }

    const saveAndCloseTimesheet = () => {
        document.body.style.cursor = 'wait'  
        axios.post(`${baseUrl}/updatetimesheet`, {
            timesheetId: props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].timesheetId,
            families: families
        })
        .then((res) => {
            props.updateTimesheets(res.data)
            props.setOpenUpTheTimesheet(false)
            props.setShowNotes(false)
            document.body.style.cursor = 'pointer' 
        })
        .catch((err) => {
            document.body.style.cursor = 'pointer' 
            props.setOpenUpTheTimesheet(false)
            props.setShowNotes(false)
            console.log(err)
        })
    }
    const saveAndSubmitTimesheet = () => {
        if(warningText.length === 0) {
            axios.post(`${baseUrl}/updatetimesheet`, {
                timesheetId: props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].timesheetId,
                families: families
            })
            .then((res) => {
                if(props.generateInvoicesFromTimesheet) {
                    props.generateInvoicesFromTimesheet(props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].timesheetId)
                }
            })
            .catch((err) => {
                console.log(err)
                alert('Timesheet did not save or send!')
            })
        }
    }
    const wrapperClickClose = (id) => {
        if(id === "edit-timesheet-timesheet-wrapper__new") {
            //props.setOpenUpTheTimesheet(false)
            saveAndCloseTimesheet()
        }
    }

    const deleteTimesheet = (id) => {
        axios.delete(`${baseUrl}/teachertimesheet/${id}`, myHeader)
        .then((res) => {
            props.removeDeletedTimesheet(res.data.timesheetId)
            props.setOpenUpTheTimesheet(false)
            props.setShowNotes(false)
        })
        .catch((err) => {
          console.log(err)
        })
      }

      const addWaveIdToFamilyInformation = (timesheetId, familyId, waveId) => {
        let notStateTimesheets = props.timesheets
        let familyToGetInfoAbout;
        for(let i = 0; i < props.listOfFamilies.length; i++) {
            if(props.listOfFamilies[i].familyId === familyId) {
                familyToGetInfoAbout = props.listOfFamilies[i]
            }
        }
        for(let i = 0; i < notStateTimesheets.length; i++) {
            if(notStateTimesheets[i].timesheetId === timesheetId) {
                let families = notStateTimesheets[i].families
                for(let i = 0; i < families.length; i++) {
                    if(families[i].id === familyId) {
                        families[i].familyWaveId = waveId
                        families[i].generalFamilyInfo = familyToGetInfoAbout
                    }
                }
            }
        }
        props.setTimesheets([...notStateTimesheets])
    }


    const updateFamiliesInDatabaseWithWaveId = (familyToUpdateEmail, newWaveId, sheetId) => {
        let myUpdatedTimesheet = props.openTimesheet
        for(let i = 0; i < myUpdatedTimesheet.families.length; i++) {
            if(myUpdatedTimesheet.families[i].email === familyToUpdateEmail) {
                myUpdatedTimesheet.families[i].familyWaveId = newWaveId
            }
        }
        //ADD THE WAVE ID TO THE CORRECT FAMILY IN TEACHERS TIMESHEET
        axios.post(`${baseUrl}/updatetimesheet`, { timesheetId: sheetId, families: myUpdatedTimesheet.families}, myHeader)
        .then((res) => {
            props.setOpenTimesheet({...res.data})
            document.body.style.cursor = 'default'
            document.getElementById('family-card__generate-wave-id-btn').style.cursor = "default"
        })
        .catch((err) => {console.log(err)})
    }


    return(
        <div className="edit-timesheet-timesheet-wrapper__new" id="edit-timesheet-timesheet-wrapper__new" onClick={(e) => wrapperClickClose(e.target.id)}>
            {props.listOfTeachersTimesheetsForThisMonth.length > 1 && currentTimesheetNumber > 0 ? <div className='flip-backward-timesheet' onClick={() => setCurrentTimesheetNumber((prev) => prev - 1)} ><ChevronLeftIcon color='black' /></div> : null}
            <div className="create-timesheet">
                {warningText.length > 0 && <TimesheetWarningPopup warningText={warningText} />}
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => saveAndCloseTimesheet()}>X</h3>
                </div>
                <h1>{props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].teacherName}</h1>
                <p className='create-timesheet__status-header' style={props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].status === 'submitted' ? {color: '#7e5611', backgroundColor: '#f5ddb3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'} : {color: '#117e18', backgroundColor: '#bcf5b3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'}}>{props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].status}</p>
                <h2>{props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].monthYear}</h2>
                <div className="family-card-section">
                    {families.map((fam, index) => <FamilyCard key={fam.id} index={index} fam={fam} reviewing={true} timesheet={props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber]} addWaveIdToFamilyInformation={addWaveIdToFamilyInformation} updateFamiliesInDatabaseWithWaveId={updateFamiliesInDatabaseWithWaveId} listOfFamilies={props.listOfFamilies} listOfFamiliesForTeachers={listOfFamiliesForTeachers} month={monthNumber} changeFamilyName={changeFamilyName} autoOpenFamilyCardWhenNameIsSelected={autoOpenFamilyCardWhenNameIsSelected} removeFamily={removeFamily} addLesson={addLesson} removeLesson={removeLesson} addCancellation={addCancellation} removeCancellation={removeCancellation} editLesson={editLesson} submitLastName={submitLastName} editCancellation={editCancellation} addExtra={addExtra} editExtra={editExtra} removeExtra={removeExtra} />)}
                </div>
                <div className="add-family" onClick={() => addFamily()}>+ Add Family</div>
                <div className="create-timesheet-bottom-sections">
                    <p className="display-the-note"><strong>Note:</strong> {props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].note}</p>
                    {note !== '' && <div className="create-timesheet-pencil"></div>}
                    <h3 className="create-timesheet__estimated-pay">Estimate Pay: ${estimatedPay}</h3>
                    <div>
                       <div className="admin-timesheet-submit-btn solid-red" onClick={() => deleteTimesheet(props.listOfTeachersTimesheetsForThisMonth[currentTimesheetNumber].timesheetId)}>Delete Timesheet</div> 
                       {/* <div className="admin-timesheet-submit-btn clear-green" onClick={() => saveAndCloseTimesheet()}>Save and close</div>  */}
                       {props.generateInvoicesFromTimesheet && <div id="admin-timesheet-submit-btn-for-loading" className="admin-timesheet-submit-btn solid-green" style={warningText.length > 0 ? {color: 'gray', border: '1px solid gray', backgroundColor: '#fff', cursor: 'default'} : {color: '#fff', border: '1px solid green', backgroundColor: 'green', cursor: 'pointer'}} onClick={() => saveAndSubmitTimesheet()}>Approve Timesheet</div> }
                    </div>
                </div>
            </div>
            {props.listOfTeachersTimesheetsForThisMonth.length > 1 && currentTimesheetNumber + 1 < props.listOfTeachersTimesheetsForThisMonth.length ? <div className='flip-forward-timesheet' onClick={() => setCurrentTimesheetNumber((prev) => prev + 1)}><ChevronRightIcon color='black' /></div> : null}
        </div>
    )
}
export default EditTimesheet;